const initialState = {
  competitors: [],
  loading: false,
  createUpdateLoading: false,
  deleteLoading: false,
  error: null,
  pageCount: 0,
  total: 0,
  mapCompetitors: [],
  mapLoading: false,
  currentComments: [],
  commentsLoading: false,
};

const competitorsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "FETCH_COMPETITORS_LOADING":
      return { ...state, loading: true, error: null };

    case "FETCH_COMPETITORS_SUCCESS":
      return {
        ...state,
        loading: false,
        competitors: payload.data || [],
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_COMPETITORS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        loading: false,
        competitors: [...state.competitors, ...(payload.data || [])],
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_COMPETITORS_ERROR":
      return { ...state, loading: false, error: payload };

    case "FETCH_COMPETITORS_MAP_LOADING":
      return { ...state, mapLoading: true };

    case "FETCH_COMPETITORS_MAP_SUCCESS":
      return { ...state, mapLoading: false, mapCompetitors: payload };

    case "FETCH_COMPETITORS_MAP_ERROR":
      return { ...state, mapLoading: false };

    case "CREATE_UPDATE_COMPETITOR_LOADING":
      return { ...state, createUpdateLoading: true };

    case "CREATE_COMPETITOR_SUCCESS":
      return {
        ...state,
        createUpdateLoading: false,
        competitors: [payload, ...state.competitors],
        total: state.total + 1,
      };

    case "UPDATE_COMPETITOR_SUCCESS":
      return {
        ...state,
        createUpdateLoading: false,
        competitors: state.competitors.map((competitor) =>
          competitor?.id === payload?.id ? payload : competitor
        ),
      };

    case "CREATE_UPDATE_COMPETITOR_ERROR":
      return { ...state, createUpdateLoading: false };

    case "DELETE_COMPETITOR_LOADING":
      return { ...state, deleteLoading: true };

    case "DELETE_COMPETITOR_SUCCESS":
      return {
        ...state,
        deleteLoading: false,
        competitors: state.competitors.filter(
          (competitor) => `${competitor?.id}` !== `${payload}`
        ),
        total: Math.max(state.total - 1, 0),
      };

    case "DELETE_COMPETITOR_ERROR":
      return { ...state, deleteLoading: false };

    case "FETCH_COMMENTS_COMPETITOR_LOADING":
      return { ...state, commentsLoading: true };

    case "FETCH_COMMENTS_COMPETITOR_SUCCESS":
      return { ...state, currentComments: payload, commentsLoading: false };

    case "FETCH_COMMENTS_COMPETITOR_ERROR":
      return { ...state, commentsLoading: false };

    case "CREATE_COMMENTS_COMPETITOR_LOADING":
      return { ...state, commentsLoading: true };

    case "CREATE_COMMENTS_COMPETITOR_SUCCESS":
      return {
        ...state,
        commentsLoading: false,
        currentComments: [payload, ...state.currentComments],
      };

    case "UPDATE_COMPETITOR_COMMENT_SUCCESS": {
      const updatedComments = state.currentComments.map((comment) => {
        if (+comment?.id === +payload?.id) {
          return payload;
        }
        return comment;
      });
      return {
        ...state,
        currentComments: updatedComments,
        commentsLoading: false,
      };
    }

    case "DELETE_COMPETITOR_COMMENT_SUCCESS": {
      const updatedComments = state.currentComments.filter((comment) => {
        return +comment?.id !== +payload;
      });
      return {
        ...state,
        currentComments: updatedComments,
        commentsLoading: false,
      };
    }

    default:
      return state;
  }
};

export default competitorsReducer;
